import type { ReferralSummary } from '@alterium/shared';
import { api } from './client';

export const referralApi = {
  summary: () => api.get<ReferralSummary>('/referral'),
};
